import type { CSSProperties, FC, MouseEvent, ReactNode } from 'react';
import { X } from 'lucide-react';

export type IpcTagVariant = 'muted' | 'primary' | 'outline';

type Props = {
  children: ReactNode;
  variant?: IpcTagVariant;
  closable?: boolean;
  onClose?: (event?: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

/** Showcase §3 Tag / Chip（非状态 Badge） */
export const IpcTag: FC<Props> = ({
  children,
  variant = 'muted',
  closable = false,
  onClose,
  className,
  style,
  title,
}) => (
  <span
    className={['ipc-tag', `ipc-tag--${variant}`, className].filter(Boolean).join(' ')}
    style={style}
    title={title}
  >
    <span className="ipc-tag__text">{children}</span>
    {closable && (
      <button
        type="button"
        className="ipc-tag__close"
        aria-label="关闭"
        onClick={e => {
          e.stopPropagation();
          onClose?.(e);
        }}
      >
        <X size={12} aria-hidden />
      </button>
    )}
  </span>
);
